// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Checks if an error is a file read error (NotReadableError).
 *
 * This error occurs when a file that was previously selected becomes
 * inaccessible before it can be read, typically because the file was
 * moved, deleted, or its permissions were changed.
 */
export function isFileReadError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'NotReadableError';
}
